import { render, staticRenderFns } from "./on-service-article.vue?vue&type=template&id=535ce627"
import script from "./on-service-article.vue?vue&type=script&lang=js"
export * from "./on-service-article.vue?vue&type=script&lang=js"
import style0 from "./on-service-article.vue?vue&type=style&index=0&id=535ce627&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports